import type { CommonColors } from '@mui/material/styles/createPalette'

export const customCommonColors: CommonColors = {
  green0: '#D9FFEF',
  green5: '#94E9CA',
  green10: '#33CC9E',
  green15: '#169073',
  green20: '#005E47',

  blue0: '#E5ECFF',
  blue5: '#CDD7FF',
  blue10: '#646FC8',
  blue15: '#3A4392',
  blue20: '#0A1254',

  yellow0: '#FFF2D9',
  yellow5: '#FCE0AA',
  yellow10: '#FCCE76',
  yellow15: '#E7A62A',
  yellow20: '#C98706',

  orange0: '#FFE7D5',
  orange5: '#FBBB8D',

  red0: '#FFEBEB',
  red5: '#FEC8C8',
  red10: '#FF6B6B',
  red15: '#D84444',
  red20: '#932323',

  pink0: '#FFE9F6',
  pink5: '#FFC8F3',
  pink15: '#F3B0F1',

  grey0: '#EAF1F8',
  grey5: '#CED7E0',
  grey10: '#A0AEBC',
  grey15: '#72808E',
  grey20: '#3F4850',
  grey25: '#5E6972',

  purple0: '#EEE3FF',
  purple5: '#DFCBFF',
  purple10: '#73559A',

  neutral0: '#FFFFFF',
  neutral5: '#F5F8FD',
  neutral10: '#F0F3F6',
  neutral15: '#CED7E0',
  neutral30: '#5E6972',
  neutral35: '#131415',

  black20: '#131415',

  mainBackground: '#F6F9FF',
  overlay: '#13141566',

  tag1: '#0F9B93',
  tag2: '#90D1FF',
  tag3: '#9D3A99',

  turquoise0: '#CEEAFF',
  turquoise10: '#397AA5',

  black: '#131415',
  white: '#ffffff',
}

// This one is deprecated, use customCommonColors from now
export const customPalette = {
  athensGray: {
    main: '#E5E9ED',
  },
  chrysopraseBlack: {
    main: '#00442F',
  },
  chrysopraseDarker: {
    main: '#056246',
  },
  chrysopraseDark: {
    main: '#168866',
  },
  chrysopraseMedium: {
    main: '#24AD84',
  },
  chrysoprasePure: {
    main: '#36D1A2',
  },
  chrysopraseLight: {
    main: '#6BEEC6',
  },
  chrysopraseLighter: {
    main: '#CDF9EB',
  },
  chrysopraseWhite: {
    main: '#E8FFF8',
  },
  sodaliteDarker: {
    main: '#0A1254',
  },
  sodaliteDark: {
    main: '#3A4392',
  },
  sodaliteMedium: {
    main: '#646FC8',
  },
  sodalitePure: {
    main: '#8E9BFF',
  },
  sodaliteLight: {
    main: '#B8C0FF',
  },
  sodaliteLighter: {
    main: '#E8E9FF',
  },
  sodaliteWhite: {
    main: '#F8F8FF',
  },
  andesineBlack: {
    main: '#4D0303',
  },
  andesineDarker: {
    main: '#8A2828',
  },
  andesineDark: {
    main: '#B22D2D',
  },
  andesineMedium: {
    main: '#D84444',
  },
  andesinePure: {
    main: '#FF6B6B',
  },
  andesineLight: {
    main: '#FFA8A8',
  },
  andesineLighter: {
    main: '#FFD8D8',
  },
  andesineWhite: {
    main: '#FFF0F0',
  },
  tourmalinePure: {
    main: '#FF6B93',
  },
  scapolitePure: {
    main: '#FFCE86',
  },
  scapoliteDarker: {
    main: '#C17300',
  },
  scapoliteLighter: {
    main: '#FFEFD8',
  },
  saphirPure: {
    main: '#86D3FF',
  },
  tektiteBlack: {
    main: '#131415',
  },
  tektiteDarker: {
    main: '#3F4850',
  },
  tektiteDark: {
    main: '#72808E',
  },
  tektiteMedium: {
    main: '#A0AEBC',
  },
  tektitePure: {
    main: '#C4CFDA',
  },
  tektiteLight: {
    main: '#DAE6F1',
  },
  tektiteLighter: {
    main: '#EAF1F8',
  },
  tektiteWhite: {
    main: '#F4F8FF',
  },
  tektiteWhiter: {
    main: '#F8FBFF',
  },
}
